export const getIsAuthenticated = (state: any) => {
  return state?.authReducer?.isAuth;
}